export const CHANGETRIP = 'CHANGETRIP'

export const ADDADULT = 'ADDADULT'

export const MINUSADULT = 'MINUSADULT'

export const ADDCHILDREN = 'ADDCHILDREN'

export const MINUSCHILDREN = 'MINUSCHILDREN'

export const PICKDATE = 'PICKDATE'

export const ADDTOCART = 'ADDTOCART'

export const REMOVEFROMCART = 'REMOVEFROMCART'

export const AIRPORTPICKUP = 'AIRPORTPICKUP'

export const DIFFERENTHOTEL = 'DIFFERENTHOTEL'

export const MORETRIPS = 'MORETRIPS'

export const REMOVEALL = 'REMOVEALL'